<template>
  <dropdown
    :label="trans('offer.action.manage')"
    :options="dropdownOptions"
    @click.prevent
  />
</template>

<script>
import Dropdown from '@components-molecules/Dropdown.vue';
import { translationMixin } from '@elements/translation';
import { eventBus } from '@tools/event-bus';
import { URL_USER_OFFERS } from '@tools/routes/routes';

export default {
  components: { Dropdown },
  mixins: [ translationMixin ],
  props: {
    offer: { type: Object, default: () => {} },
  },
  computed: {
    dropdownOptions() {
      return [
        {
          hidden: this.offer.publishable,
          text: this.trans('offer.action.publish'),
          click: (event) => this.publish(event),
        },
        {
          hidden: this.offer.editable,
          text: this.trans(this.offer.edited ? 'offer.draft.edit' : 'offer.action.edit'),
          href: this.offer.edit_url,
          click: (event) => this.edit(event),
        },
        {
          hidden: this.offer.duplicable,
          text: this.trans('offer.action.duplicate'),
          href: this.offer.duplicate_url,
          click: (event) => event.stopPropagation(),
        },
        {
          hidden: !this.offer.blocked && this.offer.unpublishable,
          text: this.trans('offer.action.unpublish'),
          href: '#',
          click: (event) => { event.preventDefault(); this.unpublish(); },
        },
        {
          hidden: !this.offer.blocked && this.offer.deletable,
          text: this.trans('global.delete'),
          href: '#',
          click: (event) => { event.preventDefault(); this.delete(); },
        },
      ];
    },
  },
  methods: {
    delete() {
      eventBus.dispatchEvent(new CustomEvent('offer-delete', {
        detail: {
          offerHashId: this.offer.hash_id,
          redirectUrl: URL_USER_OFFERS,
        },
      }));
    },
    unpublish() {
      eventBus.dispatchEvent(new CustomEvent('offer-unpublish', {
        detail: {
          offerHashId: this.offer.hash_id,
          redirectUrl: window.location.href,
        },
      }));
    },
    publish(event) {
      eventBus.dispatchEvent(new CustomEvent('offer-review', {
        detail: {
          offerHashId: this.offer.hash_id,
          element: event.target,
        },
      }));
    },
    /**
     * Normally, the href is already defined in the backend by getEditUrl @see OfferRoutingHelper
     * But in some case, the url of setup form can't be defined in the backend
     *  (e.g when the state is expired, or unpublished)
     * So in those cases, we let @see offer/actions.js do the work
     */
    edit(event) {
      // this means href has not been defined by backend, it is basically current url (modulo some params or anchor)
      if (!window.location.href.includes(event.currentTarget.href)) {
        event.stopPropagation();

        return;
      }

      eventBus.dispatchEvent(new CustomEvent('offer-special-edit', { detail: this.offer.hash_id }));
      event.preventDefault();
    },
  },
};
</script>
